import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Grid, Box, Button } from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import { ModernLiquidTable } from "../../../components/modern-table";
import { Portlet, PortletBody } from "../../../partials/content/Portlet";
import * as qs from "query-string";
import {
  getEventWithEnrollmentsById,
  getEventSheetsById,
} from "../../../api/event";
import { truncateString } from "../../../utils/text";


export default function ViewEventPage() {
  const location = useLocation();
  const [event, setEvent] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const fetchData = React.useCallback(async () => {
    setLoading(true);
    try {
      const parsed = qs.parse(location.search);
      const data = await getEventWithEnrollmentsById(parsed.id);
      if (data) setEvent(data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [location.search]);

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleExportToSheets = async () => {
    try {
      const parsed = qs.parse(location.search);
      const data = await getEventSheetsById(parsed.id);
      if (data.spreadsheetId) {
        window.open(
          `https://docs.google.com/spreadsheets/d/${data.spreadsheetId}/edit?gid=0#gid=0`,
          "_blank"
        );
      } else {
        alert("Ralat: Tidak dapat mengeksport ke Google Sheets");
      }
    } catch (error) {
      console.log(error);
      alert("Ralat: Tidak dapat mengeksport ke Google Sheets");
    }
  };

  // Generate columns including dynamic custom fields
  const generateColumns = () => {
    const baseColumns = [
      {
        field: "_rowNumber",
        title: "No",
        width: 50,
        render: (rowData) => <p>{rowData._rowNumber}</p>,
      },
      { field: "userName", title: "Nama", width: 300 },
    ];

    // Add custom field columns if they exist
    if (event && event.customFields) {
      Object.keys(event.customFields).forEach((key) => {
        baseColumns.push({
          title: truncateString(event.customFields[key].label, 20),
          render: (rowData) => {
            const additionalInfo = rowData.additionalInfo;
            const value = additionalInfo ? additionalInfo[event.customFields[key].label] : null;
            if (typeof value !== "object") {
              return <p>{value && value.toString()}</p>;
            } else {
              return (
                <p>
                  {value &&
                    Object.keys(value).filter((k) => Boolean(value[k])).join(", ")}
                </p>
              );
            }
          },
        });
      });
    }

    return baseColumns;
  };

  return (
    <Portlet>
      <PortletBody fluid={true}>
        <Grid className="p-3" container spacing={3}>
          <Grid item xs={12}>
            <Box
              sx={{
                mb: 2,
                p: 2,
                background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)',
                borderRadius: '12px',
                backdropFilter: 'blur(10px)',
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}
            >
              <span className="kt-section__sub">
                Senarai di bawah adalah peserta yang telah mendaftar
              </span>
              <Link
                className="btn btn-secondary btn-sm"
                to={`/event/list?status=${event && event.status}`}
              >
                Kembali
              </Link>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <ModernLiquidTable
              columns={generateColumns()}
              data={event && event.enrollments ? event.enrollments : []}
              title={event ? `Senarai Peserta untuk ${event.name}` : "Senarai Peserta"}
              loading={loading}
              onRefresh={fetchData}
              emptyStateMessage="Tiada peserta berdaftar"
              customToolbarActions={
                <Button
                  variant="contained"
                  startIcon={<GoogleIcon />}
                  onClick={handleExportToSheets}
                  sx={{
                    background: 'linear-gradient(135deg, #4285F4 0%, #34A853 100%)',
                    color: '#ffffff',
                    borderRadius: '10px',
                    textTransform: 'none',
                    fontWeight: 500,
                    '&:hover': {
                      background: 'linear-gradient(135deg, #34A853 0%, #4285F4 100%)',
                      boxShadow: '0 4px 12px rgba(66, 133, 244, 0.3)',
                    },
                  }}
                >
                  Google Sheets
                </Button>
              }
              options={{
                selection: false,
                pageSize: 10,
                pageSizeOptions: [5, 10, 20, 50, 100],
              }}
            />
          </Grid>
        </Grid>
      </PortletBody>
    </Portlet>
  );
}
